<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Kết quả kiểm tra</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <ExamFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card outlined class="elevation-0">
      <StudentMarksTable :marks="marks" />
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ExamFilter from '../../../modules/exam/student/ExamFilter.vue'
import { ExamMark } from '../../../plugins/api'
import { get } from 'lodash'
import StudentMarksTable from '../../../modules/exam/student/StudentMarksTable.vue'

export default {
  components: {
    ExamFilter,
    StudentMarksTable
  },
  data() {
    return {
      marks: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  async created() {
    this.$loading.active = true
    await this.getStudentExams()
    this.$loading.active = false
  },
  methods: {
    ...mapActions('studentExam', ['fetchStudentExams']),
    async getStudentExams(query) {
      this.$loading.active = true
      const student = get(this.user, 'student._id', null)
      console.log(query)
      const marks = await ExamMark.getStudentMarks(student, { ...query })
      this.marks = marks
      this.$loading.active = false
    },
    async onFilterChanged(params) {
      await this.getStudentExams(params)
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
